import { render } from "./BookingCreate.vue?vue&type=template&id=5cf5286f"
import script from "./BookingCreate.vue?vue&type=script&lang=js"
export * from "./BookingCreate.vue?vue&type=script&lang=js"
script.render = render

export default script